export default "__VITE_ASSET__BKhVWWX9__"